import { jsx as r, jsxs as c, Fragment as l } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import "./ArrowButton-DqViaPQ-.mjs";
import { A as u } from "../icons/Arrow-DlptGprM.mjs";
const $ = () => /* @__PURE__ */ r(u, {}), w = p(
  ({
    element: d,
    buttonStyle: s = "primary",
    className: o = "",
    withArrow: t,
    arrowBackward: n,
    iconClass: e = "",
    children: i,
    lightBackground: a,
    transparent: m,
    ...h
  }, b) => /* @__PURE__ */ r("div", { className: `rds-baselink-button ${o}`, children: /* @__PURE__ */ r(
    d,
    {
      className: `
        rds-button rds-button__shared 
        ${s === "highlighted" ? "rds-baselink-button--highlighted" : `rds-button__shared--${s}`}
        ${a ? "rds-light" : ""} 
        ${a === "white" ? "rds-white" : ""} 
        ${m && s === "secondary" ? "rds-transparent" : ""}
        ${t ? "rds-arrow-button" : ""}
        ${t === void 0 ? "" : n ? "rds-arrow-button--backwards" : "rds-arrow-button--forwards"}
      `,
      ref: b,
      ...h,
      children: /* @__PURE__ */ c(l, { children: [
        t && /* @__PURE__ */ r("span", { "data-testid": "rds-button__arrow", className: `rds-button__arrow ${e}`, children: /* @__PURE__ */ r($, {}) }),
        i
      ] })
    }
  ) })
);
w.displayName = "BaseLinkButton";
export {
  w as B
};
